import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { onAuthStateChanged, type User } from "firebase/auth";
import { auth } from "../firebase";
import NewRolesCard from "../components/NewRolesCard";
import { ALL_WINDOWS, type RoleWindow } from "../utils/newRoles";
import BackLink from "../components/BackLink";
import { useNavbar } from "./DashboardLayout";

/**
 * "See all" on Home's New roles card: every open role that fits, of any age,
 * with Today / 3 days / Week / Month / All. Opens on the window Home was on.
 */
export default function NewRoles() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [user, setUser] = useState<User | null>(auth.currentUser);
  useEffect(() => onAuthStateChanged(auth, setUser), []);
  const asked = params.get("window");
  const initial = ALL_WINDOWS.some((w) => w.id === asked) ? (asked as RoleWindow) : undefined;
  const { setNavbarActions } = useNavbar();

  // The page title up top, like every page; the way back is on the page
  useEffect(() => {
    setNavbarActions(
      <div className="flex w-full min-w-0 items-center font-grotesk">
        <h1 className="truncate text-[22px] font-semibold leading-none tracking-[-.03em] text-melt-text1">
          Open roles for you
        </h1>
      </div>,
    );
    return () => setNavbarActions(null);
  }, [setNavbarActions]);

  return (
    <div className="flex w-full flex-col gap-4 pb-8 font-grotesk">
      <BackLink to="Home" onClick={() => navigate("/dashboard/home")} className="-mb-1" />
      <NewRolesCard
        user={user}
        limit={Infinity}
        initialWindow={initial}
        scope="all"
        onEditRoles={() => navigate("/settings/job-search")}
      />
    </div>
  );
}
